import { useCallback } from "react";
import type { components } from "../../api/types";
import { rowTitle, type SpecRow } from "../../lib/specLines";
import { StateChip } from "./StateChip";

type Node = components["schemas"]["Node"];

// One row of the spec column (0051 slice 3): the item's title and its one
// state chip, a full-width button that opens the drawer. No date: the drawer's
// head is the one place a row's status date shows.
export function Row({
  row,
  nodeById,
  onOpen,
  register,
}: {
  row: SpecRow;
  nodeById: ReadonlyMap<string, Node>;
  onOpen: (id: string) => void;
  // Registers the button with the column, so closing the drawer returns focus
  // to it.
  register: (id: string, el: HTMLButtonElement | null) => void;
}) {
  const id = row.node.id;
  const ref = useCallback((el: HTMLButtonElement | null) => register(id, el), [register, id]);
  return (
    <button
      ref={ref}
      type="button"
      data-testid="spec-row"
      data-row-id={id}
      onClick={() => onOpen(id)}
      className="flex w-full min-h-11 sm:min-h-0 items-center gap-3 rounded-md px-2 py-1.5 text-left break-words transition-colors hover:bg-ink-900/60"
    >
      <span className="min-w-0 flex-1 break-words text-[14px] leading-snug text-ink-200">{rowTitle(row, nodeById)}</span>
      <StateChip state={row.state} />
    </button>
  );
}
